import React from 'react';

const ShippingPolicy = () => {
  return (
    <main className="bg-white">
      {/* Banner / Hero Section */}
      <section
        className="relative bg-center bg-cover h-60 flex items-center justify-center"
        style={{ backgroundImage: "url('/images/terms-banner.jpg')" }}
      >
        <div className="bg-black bg-opacity-40 absolute inset-0" />
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-3xl md:text-4xl font-bold">
            Shipping & Delivery Policy
          </h1>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-12">
        <div className="container mx-auto px-4 space-y-8">
          <div>
            <h2 className="text-2xl font-bold mb-4 text-primary">
              Shipping & Delivery Information
            </h2>
            <p className="text-dark leading-relaxed">
              As an NGO, we do not send any physical deliveries of any kind. All donation receipts, acknowledgments, and communications are shared digitally, primarily via WhatsApp to the number provided by the donor.
            </p>
            <ul className="list-disc ml-6 mt-2 text-dark">
              <li>We do not ship or deliver any physical goods, merchandise, or documents.</li>
              <li>All receipts and communications are sent digitally, usually over WhatsApp.</li>
              <li>If you require your receipt or communication via another digital method, please contact us at <a href="mailto:jivadayamandalbhachau@yahoo.com" className="text-primary underline">jivadayamandalbhachau@yahoo.com</a> or call us at <a href="tel:+919925042930" className="text-primary underline">+91 99250 42930</a>.</li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ShippingPolicy;
